module.exports = __webpack_public_path__ + "img/trade2.6eac55c7.jpg";